// Lib
import gql from 'graphql-tag';
import { AUTH_GROUP, AUTH_LIST } from '../types';

export const authGroupList = gql`
  query AuthGroupList(
    $input: AuthGroupListInput!,
    $skipAuths: Boolean!
  ) {
    authGroupList(input: $input) {
      limit
      cursor
      hasMore
      items {
        ${AUTH_GROUP}
      }
    }
  }
`;

export const authListByGroupId = gql`
  query AuthListByGroupId($input: AuthListByGroupIdInput!) {
    authListByGroupId(input: $input) {
      items {
        ${AUTH_LIST}
      }
      hasMore
      cursor
    }
  }
`;

export const authListByGroupIds = gql`
  query AuthListByGroupId($input: AuthListByGroupIdInput) {
    authListByGroupId(input: $input) {
      limit
      skip
      hasMore
      items {
        ${AUTH_LIST}
      }
    }
  }
`;

export const authGroup = gql`
  query AuthGroup($input: AuthGroupInput, $skipAuths: Boolean = false) {
    authGroup(input: $input) {
      ${AUTH_GROUP}
    }
  }
`;
